import React from "react";
import Helmet from "react-helmet";

function CanonicalLink() {
  /**
   * Генерирует canonical URL сохраняя все параметры query string
   * @param {string} primaryDomain - Основной домен (например "https://trace.ati.su")
   * @param {boolean} forceHTTPS - Принудительно использовать HTTPS (по умолчанию true)
   * @param useQueryParameters - Переносить QueryString параметры в canonical link (по умолчанию true)
   * @returns {string} - Строка с canonical URL
   */
  function generateCanonicalUrl(primaryDomain, forceHTTPS = true, useQueryParameters = true) {
    try {
      const currentUrl = new URL(window.location.href);
      const canonicalUrl = new URL(primaryDomain);

      // Переносим path и все параметры
      canonicalUrl.pathname = currentUrl.pathname;

      if(useQueryParameters) {
        currentUrl.searchParams.forEach((value, key) => {
          canonicalUrl.searchParams.set(key, value);
        });
      }

      // Принудительный HTTPS
      if (forceHTTPS) {
        canonicalUrl.protocol = "https:";
      }

      return canonicalUrl.toString();

    } catch (e) {
      console.error("Ошибка генерации canonical URL:", e);
      return "";
    }
  }

  // NOTE: query string parameters не переносим в canonical link, таким образом избавляясь от дублирования.
  // Обоснования см. в комментариях к реквесту.
  const useQueryParameters = false;
  const canonicalUrl = generateCanonicalUrl("https://trace.ati.su", true, useQueryParameters);

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}

export default CanonicalLink;
